import { isNil, isArray } from 'lodash';
import { CustomAny } from '../../../../../types/generics';

export class FormControlValueService {
  static hasNoValue(value: CustomAny): boolean {
    return isNil(value) || value === '' || value === false || (isArray(value) && value.length === 0);
  }
}
